import type { InvoiceTimelineEvent } from '../useQueryInvoiceTimeline/types';
import type { InvoiceCommentPayload } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceTimelineEventSchema } from '../useQueryInvoiceTimeline/validations';

import { zodInvoiceCommentPayloadSchema } from './validations';

/**
 * Appends a comment event to the timeline of an invoice.
 *
 * @param invoiceId - Invoice identifier.
 * @param payload - The comment text; leading and trailing whitespace is stripped.
 * @returns The created timeline event.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/add_invoice_comment_invoices__invoice_id__comments_post
 */
export async function createInvoiceComment(
  invoiceId: UUID,
  payload: InvoiceCommentPayload,
) {
  return vestigasApi
    .post(ENDPOINT.INVOICE.CREATE_COMMENT(invoiceId), {
      json: payload,
      validate: {
        body: zodInvoiceCommentPayloadSchema,
        isResponseSensitive: true,
        response: zodInvoiceTimelineEventSchema,
      },
    })
    .json<InvoiceTimelineEvent>();
}
